import { v4 as uuidv4 } from 'uuid';
import { addScheduleAPI } from './api';
import { getStore } from '../../factory';

export async function addSchedule(subscription, schedule) {
    const session = this.env.session;
    const traceId = this.env.traceId;

    this.env.startLoadCounter({ target: 'appProgress' });
    this.loadingList[schedule.scheduleId] = true;
    this.observed.loadingList = uuidv4();

    const res = await addScheduleAPI({
        body: { calendarIds: [schedule.scheduleId] },
        store: this,
        token: session.token,
        traceId,
        subscriptionId: subscription.id,
    });

    this.env.stopLoadCounter();
    delete this.loadingList[schedule.scheduleId];
    this.observed.loadingList = uuidv4();

    if (res?.error) return;

    const subscriptionsStore = getStore('subscriptions');

    // Move schedule from available → connected locally (no full API reload)
    const existing = subscriptionsStore.connectedSchedules[subscription.id] || [];
    subscriptionsStore.connectedSchedules = {
        ...subscriptionsStore.connectedSchedules,
        [subscription.id]: [...existing, schedule],
    };

    // Clear available so getAvailableSchedules replaces rather than appends
    subscriptionsStore.availableSchedules = {
        ...subscriptionsStore.availableSchedules,
        [subscription.id]: [],
    };

    // Refresh only this card's available schedules from backend
    await subscriptionsStore.getAvailableSchedules(subscription.id);

    this.addList.push({ schedule, subscription });
    this.observed.addList = uuidv4();
}

export function removeItemFromAddlist() {
    this.addList.pop();
}
